import { QuestionFill } from "shared";
import React, { ReactNode, useMemo, useRef, useState } from "react";
import { Box, Popover } from "@mui/material"
import { HrYfmPreview, transform } from "@yandex-int/hr-components/esm/yfm/HrYfmPreview";
import { transformMarkdown } from "../../../../lib/utils/markdown";
import styles from "./component_tooltip.module.scss";

interface IComponentTooltipProps {
    tooltip: IComponentTooltipSettings;
    id: string;
    className?: string;
}

export interface IComponentTooltipSettings {
    tooltip?: string | ReactNode;
    wysiwygTooltip?: string;
    useWysiwygTooltip?: boolean;
}

export const ComponentTooltip: React.FC<IComponentTooltipProps> = ({
                                                                       id,
                                                                       tooltip,
                                                                       className
                                                                   }) => {
    const [open, setOpen] = useState<boolean>(false);
    const anchorEl = useRef<HTMLDivElement>(null);

    const showTooltip = useMemo(() => {
        return tooltip.useWysiwygTooltip ? tooltip.wysiwygTooltip : tooltip.tooltip;

    }, [tooltip])

    return showTooltip ?
        <div className={className}>
            <Box className={styles.question}
                 onClick={() => setOpen(true)}
                 ref={anchorEl}>
                <QuestionFill size={20}/>
            </Box>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl.current}
                onClose={() => setOpen(false)}
                anchorOrigin={{
                    vertical: "center",
                    horizontal: "right"
                }}
                transformOrigin={{
                    vertical: "center",
                    horizontal: "left"
                }}
                sx={{
                    "& .MuiPopover-paper": {
                        borderRadius: "12px",
                        margin: "2px 0 0 2px"
                    },
                }}
            >
                {tooltip.useWysiwygTooltip && tooltip.wysiwygTooltip && <div className={styles.xxTextWysiwyg}>
                    <HrYfmPreview html={transform({ content: tooltip.wysiwygTooltip, isWiki: true })}/>
                </div>}
                {!tooltip.useWysiwygTooltip && <div className={styles.xxText}>
                    {transformMarkdown(tooltip.tooltip)}
                </div>}
            </Popover>
        </div> : null;
};
